/**
 * Get form value with fallback to selected user's value.
 * Handles the common pattern for edit forms where form value
 * takes precedence over the original value.
 * Ensures a defined value is always returned so controlled inputs stay controlled.
 *
 * @param {*} formValue - The current form field value
 * @param {*} defaultValue - The fallback value (default: "")
 * @returns {*} The form value if defined and not empty string, otherwise the default value
 */
export const getFormValue = (formValue, defaultValue = "") =>
  formValue != null && formValue !== "" ? formValue : defaultValue;

/**
 * Get form value for select fields, finding the matching option.
 * Ensures a defined value is always returned so controlled inputs stay controlled.
 *
 * @param {*} formValue - The current form field value
 * @param {*} defaultValue - The fallback value to match against options
 * @param {Array} options - Array of option objects
 * @param {string} matchField - The field name to match against (default: "value")
 * @returns {*} The form value if defined and not empty string, otherwise the matching option or ""
 */
export const getSelectFormValue = (
  formValue,
  defaultValue,
  options,
  matchField = "value",
) =>
  formValue != null && formValue !== ""
    ? formValue
    : options?.find((opt) => opt[matchField] === defaultValue) || "";
